var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRfGroupActiveIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M10 16.5c-5.5-4-7-7.2-7-9.4a3.1 3.1 0 0 1 5.6-1.8L10 6.7l1.4-1.4A3.1 3.1 0 0 1 17 7.1c0 2.2-1.5 5.4-7 9.4Z"
})));
export default SvgRfGroupActiveIcon;